import { createStore, applyMiddleware, compose } from 'redux';
import { thunk } from 'redux-thunk'; // Correct way to import thunk
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage/session'; // defaults to localStorage for web
import reducer from './reducers';

const persistConfig = {
  key: 'root',
  storage,
  // Los catalogos y precios (carreras) son transitorios: se re-piden en cada
  // sesion y NO deben sobrevivir recargas (un slot de precio viejo persistido
  // puede mostrar un precio que ya no aplica). La copia durable de los precios
  // elegidos vive en respuestas.checkoutSummary.
  blacklist: ['carreras'],
  // v2: state.carreras.valor paso de un slot unico {data} a {normal, comunidad}.
  // Si sessionStorage trae el shape viejo (sesion en curso durante un deploy),
  // se descarta el slice de carreras y se deja que los catalogos se re-pidan.
  version: 2,
  migrate: (state) => {
    if (state && state.carreras && state.carreras.valor && !state.carreras.valor.normal) {
      const { carreras, ...rest } = state;
      return Promise.resolve(rest);
    }
    return Promise.resolve(state);
  },
};

const persistedReducer = persistReducer(persistConfig, reducer);

const composeEnhancers =
  typeof window === 'object' &&
  window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ?
  window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
    // Specify extension’s options like name, actionsBlacklist, actionsCreators, serialize...
  }) : compose;

const enhancer = composeEnhancers(
  applyMiddleware(thunk),
  // other store enhancers if any
);

const store = createStore(persistedReducer, enhancer);
const persistor = persistStore(store);

export { store, persistor };
